<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import PageTransition from "../../components/PageTransition.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import { goto, params } from "@roxi/routify";
    import { fade, fly } from "svelte/transition";
    import { t } from "../../helpers/translation";
    import hi from "date-fns/locale/hi";
    import { onMount } from "svelte";

    type History = {
        id: number;
        title: string;
        date: string;
        image: string;
        bodyhtml: string;
    };

    let history_lightbox_data: History = null;

    const loadData = async (): Promise<History[]> => {
        const data: History[] = await fetch(`/api/history/`)
            .then((data) => data.json())
            .then((data) => data)
            .catch((err) => console.error(err));

        return data ? Promise.resolve<History[]>(data) : Promise.reject(null);
    };

    onMount(() => {
        $goto("/aktuelles/news");
    });
</script>

<LightTheme />

<Hero headline={$t("page.growth.hero.headline")} small />

<Container>
    <Headline>
        {@html $t("page.growth.headline")}
    </Headline>
    <Subline>
        {@html $t("page.growth.subline")}
    </Subline>
    <p>
        {@html $t("page.growth.p.1")}
    </p>
    <p>
        {@html $t("page.growth.p.2")}
    </p>
</Container>

<Container>
    {#await loadData()}
        {$t("fetch.posts.loading")}
    {:then histories}
        <div class="history-container">
            {#if histories.length == 0}
                {$t("fetch.posts.empty")}
            {/if}
            {#each histories as history}
                <div class="history">
                    <div
                        class="image"
                        style:background-image={`url('${
                            history.image ||
                            "https://liveicom.azureedge.net/sinus/img/defaults/sinus_placeholder_dark.svg"
                        }')`}
                    >
                        <time
                            >{new Date(history.date).toLocaleDateString()}</time
                        >
                    </div>
                    <div class="content">
                        <h3>{history.title}</h3>
                        <div class="text">
                            {history.bodyhtml.replace(/<[^>]*>?/gm, "")}
                        </div>
                        <!-- <div class="show-lightbox">
                            <Btn on:click={() => (history_lightbox_data = history)} small>
                                mehr lesen
                            </Btn>
                        </div> -->
                    </div>
                </div>
            {/each}
        </div>
    {:catch err}
        {$t("fetch.posts.error")}
    {/await}
</Container>

{#if history_lightbox_data}
    <div class="history-lightbox" transition:fade={{ duration: 250 }}>
        <div
            class="history"
            transition:fly={{ duration: 350, delay: 350, y: 150 }}
        >
            <div
                class="image"
                style:background-image={`url('${
                    history_lightbox_data.image ||
                    "https://liveicom.azureedge.net/sinus/img/defaults/sinus_placeholder_dark.svg"
                }')`}
            >
                <time
                    >{new Date(
                        history_lightbox_data.date,
                    ).toLocaleDateString()}</time
                >
            </div>
            <h3>{history_lightbox_data.title}</h3>
            <div class="text">{@html history_lightbox_data.bodyhtml}</div>
            <Gap height="2rem" />
            <center>
                <Btn on:click={() => (history_lightbox_data = null)}
                    >Schließen</Btn
                >
            </center>
        </div>
    </div>
{/if}
<div class="lightbox" />

<style lang="scss">
    @import "../../vars";

    .text {
        &,
        & * {
            line-height: 1.4;
        }
    }

    .history-container {
        display: grid;
        grid-template-columns: 1fr;
        gap: 2rem;

        .history {
            height: 16rem;
            width: 100%;
            border-radius: 2rem;
            display: grid;
            grid-template-columns: 16rem auto;
            justify-items: center;
            @media (max-width: 800px) {
                grid-template-columns: 1fr;
                height: auto;
                .image {
                    max-width: 100%;
                    width: 100% !important;
                    height: 0rem !important;
                    border-radius: unset !important;
                    padding-top: 56.25%;
                    time {
                        // top: unset !important;
                        // right: unset !important;
                        // bottom: 0;
                        // left: 0;
                        background-color: $grayLight !important;
                        color: $grayDark !important;
                    }
                }
                .content {
                    border-radius: unset !important;
                    border-bottom-left-radius: 1rem !important;
                    border-bottom-right-radius: 1rem !important;
                    .text {
                        -webkit-line-clamp: 10000 !important;
                    }
                }
                .show-lightbox {
                    display: none;
                }
            }
            * {
                // color: $grayDark;
            }
            .image {
                background-size: cover;
                background-position: center;
                width: 16rem;
                height: 16rem;
                border-top-left-radius: 1rem;
                border-bottom-left-radius: 1rem;
                position: relative;
                time {
                    position: absolute;
                    right: 0;
                    top: 0;
                    padding: 0.5rem;
                    background-color: $grayLight2;
                    color: $grayDark;
                    border-bottom-left-radius: 0.5rem;
                }
            }
            .content {
                background-color: $grayLight2;
                width: 100%;
                height: 100%;
                border-top-right-radius: 1rem;
                border-bottom-right-radius: 1rem;
                // border: 1px solid $gray;
                // border-left: 0;
                padding: 2rem;
                h3 {
                    margin-bottom: 0.5rem;
                    margin-top: 0;
                    font-size: 1.5rem;
                    -webkit-box-orient: vertical;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                }
                .text {
                    font-size: 1.1rem;
                    // -webkit-box-orient: vertical;
                    // display: -webkit-box;
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    // white-space: normal;
                    // -webkit-line-clamp: 3;
                    margin-bottom: 0.5em;

                    :global(p) {
                        margin: 0.5em 0 !important;
                    }
                    @media (max-width: 800px) {
                        max-height: unset;
                    }
                }
            }
        }
    }

    .history-lightbox {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba($grayDark2, 0.95);
        backdrop-filter: blur(5px);
        display: grid;
        place-items: center;
        overflow: auto;
        z-index: 20;
        padding: 6rem 2rem;
        .history {
            width: 100%;
            max-width: 1000px;
            .image {
                width: 100%;
                height: 0;
                padding-top: 66%;
                background-size: cover;
                background-position: center;
                position: relative;
                time {
                    color: $grayLight;
                    background: $grayDark2;
                    bottom: 0;
                    left: 0;
                    position: absolute;
                    padding: 1rem;
                    border-top-right-radius: 1rem;
                }
            }
            h3 {
                font-size: 2rem;
                color: $grayLight2;
            }
        }
    }
</style>
